
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-leader/prospects-clients",
      function () {
        return require("private-next-pages/industry-leader/prospects-clients/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-leader/prospects-clients"])
      });
    }
  